import { Bus } from "baconjs"
import React, { ForwardedRef, useEffect, useState } from "react"

import { ComponentFactory } from "@encoway/react-configurator"

import { IAppSettings } from "../../appUtil"
import { ComponentName } from "../../constants"
import { IVisualEditor } from "../../services/visualization/visualizationService.types"
import { IAssemblyAppProps } from "../AssemblyApp/AssemblyApp.types"
import { ICUIAppProps } from "../CUIApp/CUIApp.types"
import { AppSwitchProps } from "./AppSwitch.types"

const cuiAppProps = (
    props: AppSwitchProps,
    settings?: IAppSettings,
    eventBus?: Bus<unknown>
) => {
    return (
        settings
            ? {
                  eventBus: eventBus || new Bus(),
                  ...props,
                  settings
              }
            : props
    ) as ICUIAppProps
}
const assemblyAppProps = (
    props: AppSwitchProps,
    settings?: IAppSettings,
    eventBus?: Bus<unknown>
) => {
    return (
        settings
            ? {
                  eventBus: eventBus || new Bus(),
                  ...props,
                  settings
              }
            : props
    ) as IAssemblyAppProps
}

const IAppSwitch = (
    props: AppSwitchProps,
    visualEditorForwardRef: ForwardedRef<IVisualEditor>
) => {
    const [settings, setSettings] = useState<IAppSettings>()
    const urlParameters = new URLSearchParams(window.location.search)

    const [visualizationMode, setVisualizationMode] = useState(
        urlParameters.get("visualizationMode")
    )
    useEffect(() => {
        if (!visualizationMode) {
            Promise.resolve(props.settings).then(setSettings)
        }
    }, [])
    useEffect(() => {
        if (!visualizationMode && settings) {
            setVisualizationMode(settings?.visualization?.mode || "none")
        }
    }, [settings, visualizationMode])
    if (!visualizationMode && !settings) {
        return (
            <div>
                {ComponentFactory.instanceOf(
                    ComponentName.InitialLoadingSpinner,
                    {
                        show: true,
                        label: new URLSearchParams(window.location.search).get(
                            "product"
                        )
                    }
                )}
            </div>
        )
    }
    if (visualizationMode === "assembly") {
        return ComponentFactory.instanceOf(ComponentName.AssemblyApp, {
            ...assemblyAppProps(props, settings, props.eventBus),
            ref: visualEditorForwardRef
        })
    } else {
        return ComponentFactory.instanceOf(ComponentName.CuiApp, {
            ...cuiAppProps(props, settings, props.eventBus),
            ref: visualEditorForwardRef
        })
    }
}

export const AppSwitch = React.forwardRef(
    (
        props: AppSwitchProps,
        visualEditorForwardRef: ForwardedRef<IVisualEditor>
    ) => IAppSwitch(props, visualEditorForwardRef)
)
AppSwitch.displayName = "AppSwitch"
